import {createAction} from "redux-act";
import {IPreDrawPick} from "apps/DRAW_PREDICTOR/modules/reducers";

export const initPreDraw = createAction<IPreDrawPick[]>();
export const updatePreDraw = createAction<IPreDrawPick[]>();

export const editPreDraw = createAction();
export const savePreDraw = createAction();
export const resetPreDraw = createAction();

export const setPreDrawActiveIndex = createAction<number>();
